const moneySavingCard = resolve => require(['@/pages/moneySavingCard/index.vue'], resolve);
const detail = resolve => require(['@/pages/moneySavingCard/detail.vue'], resolve);

export default [
  /********************省钱卡*****************/
  {
    path: "/moneySavingCard",
    name: "省钱月卡",
    component: moneySavingCard
  },
  {
    path: "/moneySavingCard/detail",
    name: "购卡详情",
    component: detail
  },
  
]
